import AccountStatements from './AccountStatements';

export default AccountStatements;